import React from 'react'
import {IconSpinner, WineryCard} from '../../../components';
import css from './SearchResultCard.module.css';

function SearchResultCards({wineries, wineriesLoading, myFavs}) {

  if(wineriesLoading) {
    return (
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: "100px"}}>
        <IconSpinner />
      </div>
    )
  }
  return (
    <div className={css.cardWrapper}>
      {wineries()?.map(winery => (
        <WineryCard key={winery._id} winery={winery} myFavs={myFavs} />
      ))}
    </div>
  )
}

export default SearchResultCards
